import PointItem from './PointItem';

export default PointItem;
